/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.35.0 */
import "./modalSpinner-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { layers } from '@atlaskit/theme/constants';
import Spinner from '@atlaskit/spinner';
var blanketStyles = null;
var spinnerStyles = null;
var defaultProps = {
  blankedColor: 'none',
  invertSpinnerColor: false
};
export default (function (_ref) {
  var blankedColor = _ref.blankedColor,
    invertSpinnerColor = _ref.invertSpinnerColor;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: blankedColor || defaultProps.blankedColor
    },
    "data-testid": 'media-modal-spinner-blanket',
    className: ax(["_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"])
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "large",
    appearance: invertSpinnerColor || defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
    testId: 'media-modal-spinner'
  })));
});